import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#434343"
}
function BeaChi001({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M0 0l6.35 6.4.1-.1.1.1L12.9 0H0z"
                    id="BeaChi001__Symbol_8_0_Layer0_0_FILL"
                />
            </defs>
            <g id="BeaChi001__col1n" transform="translate(186.05 235.25)">
                <use
                    xlinkHref="#BeaChi001__Symbol_8_0_Layer0_0_FILL"
                    id="BeaChi001__col1n_FL"
                />
            </g>
        </g></g>
    )
}
export default BeaChi001
